<template>
  <div
    class="hub-topics-list-item min-h-[115px] p-4 gap-4 flex items-center justify-between bg-white rounded-2xl shadow-md cursor-pointer"
    :class="{
      '!cursor-not-allowed !shadow-none opacity-75 !pointer-events-none':
        isLocked,
      '!shadow-none !pointer-events-none': isReadonly
    }"
    @click="() => $emit('click', topic)"
  >
    <!-- @click="handleSelectTopic" -->

    <div
      v-if="isStars"
      class="pr-4 flex flex-shrink-0 border-r-2 border-[#D9D9D9]"
    >
      <BaseStars class="!gap-1" :value="stars" :size="24" />
    </div>

    <div class="w-full h-full gap-2 flex justify-center flex-col">
      <span class="text-xl font-bold" :class="{ 'text-[#B3B3B3]': isLocked }">
        <!-- {{ isAdaptationAllowed ? '🪄' : '' }} -->
        {{ topic.name }}</span
      >

      <div
        v-if="answersSubtitle"
        class="gap-2 flex items-center text-sm text-[#B3B3B3]"
      >
        {{ answersSubtitle }}
      </div>

      <div class="flex" :class="{ 'opacity-50': isLocked }">
        <TopicsListItemLevelChip :topic="topic" />
      </div>
    </div>

    <div v-if="!isReadonly">
      <BaseIcon v-if="isLocked" class="text-xl text-[#B3B3B3]" icon="lock" />
      <BaseIcon v-else class="text-xl text-[#7C7C7C]" icon="angle-right" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

// import { ADAPTATION_ALLOWED_TOPICS } from '@/utils/consts'

import BaseIcon from '@/components/Base/BaseIcon.vue'
import BaseStars from '@/components/Base/BaseStars.vue'
import TopicsListItemLevelChip from '@/components/Hub/Topics/TopicsListItemLevelChip.vue'

export default {
  name: 'HubTopicsListItem',

  components: { BaseIcon, BaseStars, TopicsListItemLevelChip },

  inject: {
    isStars: { default: true },
    isReadonly: { default: false },
    isRandomStars: { default: false }
  },

  props: {
    topic: { type: Object, required: true },
    index: { type: Number, required: true },
    sectionSlug: { type: String, required: true }
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('auth', ['isAuthorized']),
    ...mapGetters('topics', [
      'defineIsPremiumTopicBySlug',
      'defineIsLockedForDemo'
    ]),

    isPaywall() {
      return this.$route?.name?.includes('paywall')
    },

    answersSubtitle() {
      return this.topic.possibleAnswers.join(', ')
    },

    stars() {
      if (this.isPaywall || this.isRandomStars) {
        return this.randomStars
      }

      if (!this.user) return 0

      const sectionRecord = this.user.sectionRecords?.[this.sectionSlug]
      const topicRecord = sectionRecord?.[this.topic.slug]

      return topicRecord?.stars || 0
    },

    randomStars() {
      return Math.floor(Math.random() * 3 + 2)
    },

    // isAdaptationAllowed() {
    //   return ADAPTATION_ALLOWED_TOPICS.includes(this.topic.slug)
    // },

    isLocked() {
      if (this.isReadonly) return false
      if (this.isPaywall) return false

      const isLockedForDemo = this.defineIsLockedForDemo(this.topic.slug)

      return isLockedForDemo && !this.user?.isPremium
      // const isPremiumTopic = this.defineIsPremiumTopicBySlug(this.topic.slug)

      // return isPremiumTopic && !this.user?.isPremium
    }
  },

  methods: {
    ...mapMutations('ui', {
      setUiAuthModal: 'SET_UI_AUTH_MODAL',
      setUiTariffsModalIsVisible: 'SET_UI_TARIFFS_MODAL_IS_VISIBLE'
    })

    // handleSelectTopic() {
    //   if (!this.isLocked) return

    //   if (this.isAuthorized) {
    //     this.setUiTariffsModalIsVisible(true)
    //     return
    //   }

    //   this.setUiAuthModal({ isVisible: true })
    // }
  }
}
</script>
